import React, { useState, useEffect } from 'react';
//import { isAuthenticated, getAccessToken, getLogin } from "../Utility/WPAuth"
import parse from 'html-react-parser';
import { useAuth } from "../Contexts/AuthContext"
import Parser, { domToReact } from 'html-react-parser';
//import { Link } from "react-router-dom";
import { getBaseURL } from '../Utility/getBaseURL'

function ParseCartItems(data, fetchCart) {
	const output = Parser( data, {
		trim: true,
		replace: (domNode) => {
			switch(domNode.name) {
				case 'a':
					if(domNode.attribs.class && domNode.attribs.class.includes('remove_from_cart_button')) {
						return <button onClick={(ev)=>{
							fetch(domNode.attribs.href, {credentials:'include',redirect: 'manual',}).then(()=> {
								fetchCart();
							})
						}} className={domNode.attribs.class}>{domToReact(domNode.children)}</button>
					}
					return domNode;
				default:
					return domNode;
			}
		}
	});
	return output;
}

function MiniCart() {
	const baseURL = getBaseURL()	
	const [cart, setCart] = useState(false);
	//const [loading, setLoading] = useState(false);

	useEffect(() => {
		async function fetchCart() {
			let response = await fetch(baseURL + '?wc-ajax=get_refreshed_fragments', {credentials:'include'})
			response = await response.json()
			response.fragments['div.widget_shopping_cart_content'] = ParseCartItems( response.fragments['div.widget_shopping_cart_content'], fetchCart );
			setCart(response)
	    }
	    fetchCart()
   		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	return (
		<ul id="site-header-cart" className="site-header-cart">
			<li>
				{cart && parse( cart.fragments['a.cart-contents'] )} 
				{!cart && <a className="cart-contents .header-top-right-quicknav" href={baseURL+"/checkout/"} title="View your shopping cart"><span className="amount">$0.00</span> <span className="count">0</span></a>}
			</li>
			<li>
				<div className="widget woocommerce widget_shopping_cart">
					{cart && cart.fragments['div.widget_shopping_cart_content'] }
					{!cart && <div className="widget_shopping_cart_content"><p className="woocommerce-mini-cart__empty-message">No products in the cart.</p></div>}
				</div>		
			</li>
		</ul>
	)
}

function AccountButtons() {
	const {login} = useAuth();
	const baseURL = getBaseURL()	
	return (
		<React.Fragment>
			{!login && <a href={baseURL+"/my-account/sign-in/"} title="Sign In" className="header-top-right-quicknav quicknav-sign-in"><span>Sign In</span></a>}
			{login && <a href={baseURL+"/my-account/"} title="My Account" className="header-top-right-quicknav quicknav-my-account"><span>My Account</span></a>}
			{!login && <a href={baseURL+"/my-account/create-account/"} title="Create Account" className="header-top-right-quicknav quicknav-create-account"><span>Create Account</span></a>}
			{login && <a href={baseURL+"?customer-logout=true"} title="Log Out" className="header-top-right-quicknav quicknav-logout"><span>Log Out</span></a>}
		</React.Fragment>
	)
}

const HeaderTopRight = () => (
	<div className="header-top-right">
		<AccountButtons/>
		<MiniCart/>
	</div>
)

export default HeaderTopRight